import UploadFileCropper from './UploadFileCropper';

export default UploadFileCropper;
